module.exports = __webpack_public_path__ + "img/logo-name.d5b6aaa0.svg";